function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaveGamesTemplate = require('./save-games.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaveGamesOverlay = /*#__PURE__*/function () {
  function SaveGamesOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SaveGamesOverlay);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(this.app, this.mod);
  }
  return _createClass(SaveGamesOverlay, [{
    key: "formatElapsed",
    value: function formatElapsed(time_played) {
      var res = this.app.browser.formatTime(time_played) || {};
      var hours = res.hours || 0;
      var minutes = res.minutes || 0;
      var seconds = res.seconds || 0;
      var hours_full = '';
      var minutes_full = '00:';
      var seconds_full = '00';
      if (hours != 0) {
        hours_full = (hours < 10 ? '0' : '') + hours.toString() + ':';
      }
      if (minutes != 0) {
        minutes_full = (minutes < 10 ? '0' : '') + minutes.toString() + ':';
      }
      if (seconds != 0) {
        seconds_full = (seconds < 10 ? '0' : '') + seconds.toString();
      }
      return hours_full + minutes_full + seconds_full;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var app, mod, container, i, s, stxmsg, time_elapsed, screenshot, html;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              app = this.app;
              mod = this.mod;
              _context.n = 1;
              return this.reloadSaves();
            case 1:
              this.overlay.show(SaveGamesTemplate(app, mod));
              container = document.getElementById('nwasm-saved-games');
              if (container) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              container.innerHTML = '';
              if (mod.active_game_saves.length) {
                _context.n = 3;
                break;
              }
              container.innerHTML = "<div class=\"empty\">No saved games yet.</div>";
              return _context.a(2);
            case 3:
              for (i = 0; i < mod.active_game_saves.length; i++) {
                s = mod.active_game_saves[i];
                stxmsg = s.returnMessage();
                time_elapsed = this.formatElapsed(stxmsg.time_played);
                screenshot = stxmsg.screenshot || '';
                html = "\n        <button type=\"button\" id=\"save_game_".concat(i, "\" data-id=\"").concat(s.signature, "\" class=\"item\">\n          <div class=\"shot\">\n            ").concat(screenshot ? "<img src=\"".concat(screenshot, "\" alt=\"Save ").concat(i + 1, "\" />") : "<div class=\"placeholder\"></div>", "\n            <div class=\"time\">").concat(time_elapsed, "</div>\n          </div>\n        </button>\n      ");
                app.browser.addElementToId(html, 'nwasm-saved-games');
              }
              this.attachEvents();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "reloadSaves",
    value: function () {
      var _reloadSaves = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        var sgo_self;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.mod.active_rom_sig) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              sgo_self = this;
              this.mod.active_game_saves = [];
              return _context2.a(2, new Promise(function (resolve) {
                _this.app.storage.loadTransactions({
                  field1: 'Nwasm' + _this.mod.active_rom_sig,
                  limit: 10
                }, function (txs) {
                  try {
                    for (var z = 0; z < txs.length; z++) {
                      sgo_self.mod.active_game_saves.push(txs[z]);
                    }
                  } catch (err) {
                    console.log('error reloading Nwasm saves...: ' + err);
                  }
                  resolve();
                }, 'localhost');
              }));
          }
        }, _callee2, this);
      }));
      function reloadSaves() {
        return _reloadSaves.apply(this, arguments);
      }
      return reloadSaves;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var mod = this.mod;
      var sgo = this;
      for (var i = 0; i < mod.active_game_saves.length; i++) {
        var obj = document.getElementById("save_game_".concat(i));
        if (obj) {
          obj.onclick = function (e) {
            var sig = e.currentTarget.getAttribute('data-id');
            sgo.overlay.hide();
            mod.loadSaveGame(sig);
          };
        }
      }
    }
  }]);
}();
module.exports = SaveGamesOverlay;